import { ReactNode, createContext } from "react";

export type PortalProviderProps = {
  root?: HTMLElement | React.MutableRefObject<HTMLElement | null> | null;
  children?: ReactNode;
};

export type PortalProviderContextProps = {
  root?: HTMLElement | React.MutableRefObject<HTMLElement | null> | null;
};

export const PortalProviderContext = createContext<PortalProviderContextProps>(
  {},
);
